import { clientFactory } from './factories';

export const xAPIEventsModuleClient = clientFactory({});
